import { convertUTCToLocal } from "@/utility/dateHelper";

export const GetFormattedOrder = (apiResponse = {}) => {
    const {
        orders,
        totalRecords = '',
        totalPages = '',
        pageSize = '',
        currentPage = '',
        activeCount = '',

    } = apiResponse;

    const formattedOrder = orders?.map(GetOrders);
    return {
        data: formattedOrder,
        totalRecords,
        totalPages,
        pageSize,
        currentPage,
        activeCount,
    };
};

// Helper function to map individual items
const GetOrders = (item = {}) => {
    const {
        orderId = "",
        orderState= "",
        orderSubState = "",
        storeId = "",
        deliveryDate = "",
        orderDate = "",
        updatedDate = "",
        localDeliveryDate = "",
        soldCustomerId = "",
        orderType = "",
    } = item;

    return {
        orderId,
        orderState,
        orderSubState,
        storeId,
        deliveryDate: convertUTCToLocal(deliveryDate),
        orderDate: convertUTCToLocal(orderDate),
        updatedDate: convertUTCToLocal(updatedDate),
        localDeliveryDate: convertUTCToLocal(localDeliveryDate),
        soldCustomerId,
        orderType
    };
};
